import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children, redirectTo = "/" }) => {
  const { isAuthenticated, isAdmin } = useSelector((state) => state.auth);

  // Check localStorage directly as well
  const token =
    localStorage.getItem("accessToken") || localStorage.getItem("userToken");
  const isAdminAuth = localStorage.getItem("isAdminAuthenticated") === "true";
  const userData = localStorage.getItem("user");

  const isAuth = isAuthenticated || (token && userData);

  // If user is logged in, redirect to appropriate dashboard
  if (isAuth) {
    // If it's an admin route and user is admin, redirect to admin dashboard
    if (redirectTo === "/admin") {
      if (isAdmin || isAdminAuth) {
        return <Navigate to="/admin" replace />;
      }
      // If not admin but logged in, redirect to user dashboard
      return <Navigate to="/user" replace />;
    }

    // For user routes, redirect to user dashboard
    return <Navigate to="/user" replace />;
  }

  // If not logged in, render the public page
  return children;
};

export default PublicRoute;
